import styled from 'styled-components/macro';
import { colorCoreBlack300, colorCoreBlack900Base } from '@yme/tokens/colors';
import { typographyTextShadow } from '@yme/tokens/elevations';
import { ADAPTIVE } from '@yme/tokens/screen';
import { getTypography, letterSpacingXS } from '@yme/tokens/typography';
import { TYPOGRAPHY_MAP } from '@yme/utils/constants';
import { getTextStyles } from '@yme/utils/styles';
export const RichTextStyled = styled.div `
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    color: ${colorCoreBlack900Base};
    text-transform: uppercase;
    text-shadow: ${typographyTextShadow};
    margin: 16px 0;
  }

  ul,
  ol,
  p {
    ${({ paragraphTextColor }) => getTypography({
    variant: TYPOGRAPHY_MAP.textBody16,
    color: paragraphTextColor || colorCoreBlack300,
})}
  }

  h1 {
    ${getTextStyles('Play', 700, 28, 32)}
    ${letterSpacingXS}
  }

  h2 {
    ${getTextStyles('Play', 700, 24, 28)}
    ${letterSpacingXS}
  }

  h3 {
    ${getTextStyles('Play', 700, 18, 24)}
    ${letterSpacingXS}
  }

  h4 {
    ${getTextStyles('Play', 700, 14, 16)}
    ${letterSpacingXS}
  }

  h5 {
    ${getTextStyles('Play', 700, 14, 16)}
    ${letterSpacingXS}
  }

  ${ADAPTIVE.maxWidth.desktop} {
    h1 {
      ${getTextStyles('Play', 700, 48, 56)}
      ${letterSpacingXS}
    }

    h2 {
      ${getTextStyles('Play', 700, 32, 40)}
      ${letterSpacingXS}
    }

    h3 {
      ${getTextStyles('Play', 700, 24, 28)}
      ${letterSpacingXS}
    }

    h4 {
      ${getTextStyles('Play', 700, 18, 24)}
      ${letterSpacingXS}
    }

    h5 {
      ${getTextStyles('Play', 700, 14, 20)}
      ${letterSpacingXS}
    }

    h6 {
      ${getTextStyles('Play', 700, 12, 18)}
      ${letterSpacingXS}
    }
  }
`;
